// --- 页面 2: 我的创作 ---
function CreationsPage({ onNavigate }) {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-white">我的创作 页面</h1>
      <p className="text-gray-300 mt-2">这里将显示用户保存的作品。</p>
    </div>
  );
}

export default CreationsPage;
